import { useEffect, useRef } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";
export const CLAIM_TOKEN_KEY = "kinoes_claim_token";

/**
 * After an invitee signs up/in, link their magic-link member to the new account.
 * The magic-link token was stashed in localStorage before the Auth0 redirect; we
 * send it alongside the Auth0 bearer so the API can match identity → member.
 * Renders nothing; no-ops for ordinary logins (no pending token).
 */
const ClaimHandler: React.FC = () => {
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (!isAuthenticated || ran.current) return;
    const sessionToken = localStorage.getItem(CLAIM_TOKEN_KEY);
    if (!sessionToken) return;
    ran.current = true;

    (async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        await axios.post(
          `${API_URL}/api/session/claim`,
          {},
          { headers: { Authorization: `Bearer ${accessToken}`, "X-Session-Token": sessionToken } }
        );
      } catch {
        /* expired/conflict — non-fatal, the dashboard will simply not show that family */
      } finally {
        localStorage.removeItem(CLAIM_TOKEN_KEY);
        navigate("/dashboard");
      }
    })();
  }, [isAuthenticated, getAccessTokenSilently, navigate]);

  return null;
};

export default ClaimHandler;
